export default [
  {
    path: '/admin/product-categories',
    name: 'product-category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/product-category/index.vue')
  }
]
